import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Form, FormFloating, FloatingLabel} from "react-bootstrap";
import Col from "react-bootstrap/Col";

class AgeArray extends Component {
    constructor(props) {
        super(props)
        const invalid = []
        this.inputRefs = []
        this.ages = this.props.elementProps.defaultValue || []
        for (let i = 0; i < this.ages.length; i++) {
            invalid.push(false)
            this.inputRefs.push(React.createRef())
        }
        this.state = {invalid: invalid}
        this.hasFocus = true
    }

    onKeyPress = (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.target.blur()
        }
    }
    onBlur = (e) => {
        this.hasFocus = false;
        const invalid = this.validate(e.target.value, e.target.dataset.index)
        if (!invalid && parseInt(e.target.dataset.index) === this.inputRefs.length -1) {
            setTimeout(() => {
                this.checkAll(e.target)
            }, 20)
        }
    }
    checkAll = (target) => {
        const result = []
        for (let i = 0; i < this.inputRefs.length; i++) {
            let value = this.inputRefs[i].current.value
            if (!value || value === "" || parseInt(value) > 23) {
                return
            }
            result.push(parseInt(value))
        }
        this.props.setAnswer(result)
    }
    validate = (value, i) => {
        let invalid = false;
        if (!value || value === "" || value > 23) {
            invalid = "Invalid age"
        }
        if (this.state.invalid[i] !== invalid) {
            this.setState(prevState => {
                prevState.invalid[i] = invalid
                return {invalid: prevState.invalid}
            })
        }
        return invalid;
    }
    onChange = (event) => {
        if (event.target.value > 2) {
            const nextIndex = parseInt(event.target.dataset.index) + 1;
            if (this.inputRefs.length > nextIndex) {
                this.inputRefs[nextIndex].current.focus()
            }
        }
    }
    componentDidMount() {
        if (this.props?.autoFocus){
            this.inputRefs[0].current.focus();
        }
    }
    render = () => {
        const props = {...this.props}
        props.elementProps.onKeyPress = function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                return e.target.blur()
            }
            return true
        }
        props.elementProps.onKeyUp = function (e) {

        }
        let ages = this.props.elementProps.defaultValue || []
return (
            <div className="row">
                {
                    ages.map((age, index) => {
                        const wizardStyle = props.expandedStyle === 'wizard' ? ` transitionable delay-${index+2}`:''
                        const inner = (
                            <Form.Control
                                key={`dependent-${age}-${index}`}
                                ref={this.inputRefs[index]}
                                data-index={index}
                                onFocus={props.elementProps.onFocus}
                                onBlur={this.onBlur}
                                onKeyPress={this.onKeyPress}
                                onChange={this.onChange}
                                aria-invalid="false"
                                type="tel"
                                placeholder="Age"
                                defaultValue={age}
                                className={props.elementProps.className+wizardStyle}
                            />
                        )
                        if (props?.floating){
                            return <Col key={`depAge${index}`}>
                                <FloatingLabel controlId={`dependent-${age}-${index}`} label={'Age'}>
                                    {inner}
                                </FloatingLabel>
                            </Col>
                        }
                        return (
                            <Col key={`depAge${index}`} className={props?.floating? 'form-floating':''}>
                                {inner}
                            </Col>
                        )
                    })
                }
            </div>

        )
    }
}

AgeArray.propTypes = {
    elementProps: PropTypes.object,
    setAnswer: PropTypes.func,
    ages: PropTypes.array
};
export default AgeArray;